<template>
 <div>
 <table style="position: absolute;" width="100%"  :height="this.windowSize.height-8"  :max-height="this.windowSize.height-8" >

    <tr max-height="48px" height="48px"  >
      
<ContenidoBase 
  :titulo="'Reporte de Análisis de saldos'"
  :descripcion="'Imprime las facturas vencidas.'"
   :EstadoBtn="EstadoBtn"
   @abrirBarraTablaDinamica="abrirTabla"
   @MethodNuevo="newwnuevo"
   @MethodGuardar="save"
   @MethodEliminar="remove"
   @MethodAnular="anular"
   @MethodImprimir="imprimirList"
   
/>
    </tr>
   


    
    <tr>
<!-- BarraPrimaria --------------------------------------------------------------------------------->
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraTablaDinamicaAprir">

         <div class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">
        
        <v-tooltip left>
          <template v-slot:activator="{ on }">
              <center>
              <v-btn-toggle>
                <v-btn
                  small
                  color="yellow accent-4"
                  @click.prevent="actualiza_tb_ver"
                >
                  <i style="font-size: 25px;" class="fa fa-eye"> </i> ver</v-btn
                >
                <v-btn
                  small
                  dark
                  color="deep-purple accent-2"
                  @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                >
                  <i style="font-size: 25px;" class="fa fa-print"> </i>
                  Listado</v-btn
                >
              </v-btn-toggle>
            </center>
            <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitReportesListadoConduce'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
          </template>
        </v-tooltip>

      </div>
      </td>
<!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
<!-- contenido central ------------------------------------------------------------------------------ -->
      <td :max-height="this.windowSize.height-96" >
        <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
 

 <v-container >
  <v-card color="grey lighten-3">

<v-toolbar
        flat
        color="#BDBDBD"
        dense
        style="border: 1px solid #000000;"
      >
        
  
 <v-avatar tile  size="45"  >
      <img
        src="@/assets/iconos_micromarket/custom-reports.png"
        alt="Reporte"
      >
    </v-avatar>

    
<span class="font-weight-light" style="font-size: 20px;" > Reporte de análisis de saldos </span >

  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
   <!-- style="color:white;" -->
    <!-- <i class=""> </i> -->

        <!-- <v-spacer></v-spacer> -->
        <!-- <v-btn
          color="grey darken-4"
          fab
          small
          @click="cerrarmodalcuenta"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn> -->
      </v-toolbar>
           
<hr>

  <v-container style="border: 1px solid #000000;">
  <v-form ref="form" @submit.prevent=""  v-model="valid" lazy-validation>
              <v-row>
<!-- columna 1 -->
<v-col cols="12" md="6" sm="6">

  <!-- -----------------------------  Fecha de Corte  -->
<v-text-field
        dense
        outlined
        type="date"  
        label="Fecha de Corte:"
         :rules="[$rules.required]"
        v-model="AnalisisSaldos.fecha"
        @blur="Blurfecha"
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>
                </v-text-field>
<!-- ----------------------------- Tipo de Proveedor -->
<v-combobox
            autocomplete="off"
            dense
            outlined
            label="Tipo de Proveedor:"
            :items="RTipoProv"
            item-text="descripcion"
            v-model="AnalisisSaldos.tipo"
            @blur="SelctCbTipoProveedor"
            @focus="cargarTipoProveedor"
          >
            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-handshake-o"></i>
            </template>
          </v-combobox>

</v-col>
<!-- fn columna 1 -->


<!-- columna 2 -->
<v-col cols="12" md="6" sm="6">

  <!-------------------------------------------------- proveedor -->
 <v-combobox
            autocomplete="off"
            dense
            outlined
            label="* proveedor:"
            :items="Rproveedor"
            item-text="nombre"
            v-model="AnalisisSaldos.proveedor"
            @blur="SelctCbProveedor"
            @focus="cargarProveedor"
            @keyup="CbFilProveedor"
            
          >
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-user-circle"></i>
                      </template>                                 
</v-combobox>


<v-switch
              class="mt-0"
              color="teal"
              inset 
              hide-details
              label="Formato Resumido:"
              v-model="AnalisisSaldos.Resumen"
            >
          <template v-slot:label>
         <strong v-if="AnalisisSaldos.Resumen==true" style="color:#000000;">Formato Resumido: Si</strong>
         <strong v-if="AnalisisSaldos.Resumen==false" style="color:#000000;">Formato Resumido: No</strong>
        </template>
            
            
            </v-switch>

</v-col>
<!-- fn columna 2 -->
         
              </v-row>

            </v-form>
       </v-container>

<hr>

<ModalReporteFiltros2
 ref="ModRepFilt"
@DataReporteBasico="DDataReporteBasico"
:Datos="AnalisisSaldosLink"
/>


  </v-card>
 </v-container>

        </v-app> 
      </td>
<!-- fn contenido central ------------------------------------------------------------------------------------->
<!-- BarraSecundaria ------------------------------------------------------------------------------------------>
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir" >

 <div  class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">
        
<!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
</div>

      </td>
<!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



    </tr>
  </table>
<!-- Modales -------------------------------------------------------------------------------------------------->
  <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      label="myAlert"
      v-model="acti_tb_data"
      persistent
      max-width="100%"
      max-height="100%"
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            fab
            small
            @click="acti_tb_data = !acti_tb_data"
          >
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                @keyup="filtro"
                label="Buscar"
                single-line
                hide-details
              >
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="slotHtabla"
              dense
              :items="list"
              :search="search"
              @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog
      label="myAlert"
      v-model="Elim_notif.estado"
      persistent
      max-width="350"
      transition="fab-transition"
    >
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            @click.prevent="
              eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            "
            small
          >
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%;"
      :vertical="true"
      :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

<!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import ContenidoBase from "../../components/ContenidoBase";
// import ModalReporteFiltros from "../../components/ModalReporteFiltros";
import ModalReporteFiltros2 from "../../components/ModalReporteFiltros2";
import { currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha
} from "@/js/Funciones.js";
export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ModalReporteFiltros2
  },
  created() {
    var json = {  
      titulo: "Reporte de Análisis de saldos",
      descripcion: "Imprime las facturas vencidas.",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      accion: [ 

        "ReportesAnalisisSaldosNew",
        "ReportesAnalisisSaldosSave",
        "ReportesAnalisisSaldosRemove",
        "ReportesAnalisisSaldosAnular",
        "ReportesAnalisisSaldosPrintList"
      ], 
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("ReportesAnalisisSaldosNew", this.new);
    // EventBus.$on("ReportesAnalisisSaldosSave", this.save);
    // EventBus.$on("ReportesAnalisisSaldosRemove", this.remove);
    // EventBus.$on("ReportesAnalisisSaldosAnular", this.remove);
    // EventBus.$on("ReportesAnalisisSaldosPrintList", this.imprimirList);
    EventBus.$on("emitReportesAnalisisSaldos", this.datostabla);
    EventBus.$on("onResize", this.onResize);

    this.$refs.ModRepFilt.CrearObjecto=this.validarObjecto;
  },

  data:()=>  ({

      Rpropietario:[],
      Rproveedor:[],
      RCaja:[],
      RTipoProv:[],
      ListaTiposClientes: [],
      windowSize:{width:"auto", height:"auto"},

AnalisisSaldosLink:{
        nombre:'REPORTE DE ANÁLISIS DE SALDOS',
        UrlImprimir: '/reportesCXP/analisis-saldo', 
        UrlExel: '/reportesCXP/Excelanalisis-saldo', 
        UrlCorreo: '/reportesCXP/Correoanalisis-saldo',
},

      AnalisisSaldos: {
        fecha: fechaNueva(),
        Resumen:true,
        tipo:null,
        proveedor:null
      },

EstadoBtn:{ 
        BarraTablaDinamicaAprir:false,
        nuevo:false,
        guardar:false,
        eliminar:false,
        anular:false,
        imprimir:false,
        vercuenta:false,
        guardartemporal:false,
        restaurartemporal:false,
        importarDato:false,
        cargarProducto:false,
        ImprimirproductoInv:false,
        },
     
      text: "",
      valid: true,
     BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:"
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" }
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?"
      },

      aalert: {
        estado: false,
        color: null
      },
    
    }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {

  currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha,

onResize(e){

console.log("imprii ")

console.log(e)
this.windowSize=e


},

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;

    },
   
    datostabla(e) {

      this.AnalisisSaldos = e;
      this.acti_tb_data=false
    },
    save() { },
    remove() { },
    eliminar() { },
    anular() {},
    imprimirList() {},
    DDataReporteBasico(){},

    validarObjecto(){

var where=" pv.codigo > 0 "
var where2=" pv.codigo > 0 "
var titulo=" "
where+=` and fp.fecha <= ' ${this.AnalisisSaldos.fecha} ' `
where2+=` and g.fecha <= ' ${this.AnalisisSaldos.fecha} ' `


if(this.AnalisisSaldos.tipo!=null){ 
titulo += " Tipo de proveedor: "+ this.AnalisisSaldos.tipo.descripcion
where +=` and pv.tipo= ${this.AnalisisSaldos.tipo.codigo}`
where2 +=` and pv.tipo= ${this.AnalisisSaldos.tipo.codigo}`
}

if(this.AnalisisSaldos.proveedor!=null){ 
titulo += " Proveedores: "+ this.AnalisisSaldos.proveedor.nombre
where +=` and pv.codigo= ${this.AnalisisSaldos.proveedor.codigo}`
where2 +=` and pv.codigo= ${this.AnalisisSaldos.proveedor.codigo}`
}else{
titulo += " Proveedores: Todos "
}

this.AnalisisSaldosLink.fechacorte=JSON.parse(JSON.stringify(this.AnalisisSaldos.fecha))
this.AnalisisSaldosLink.Resumen=JSON.parse(JSON.stringify(this.AnalisisSaldos.Resumen))
this.AnalisisSaldosLink.where=where
this.AnalisisSaldosLink.where2=where2
this.AnalisisSaldosLink.titulo=titulo


},





    newwnuevo() {
      (this.AnalisisSaldos = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: ""
      }),
        EventBus.$emit("actualizaBarraBusqueda2");
    },


cargarTipoProveedor(){

 this.$axios.get(this.$hostname+this.$hName+'/tipoproveedor/findallactivos',{headers:this.$store.getters.GetheadersAxios})
.then(res=>( this.RTipoProv=res.data))


},

SelctCbTipoProveedor(){
 if(this.AnalisisSaldos.tipo==null){

    this.AnalisisSaldos.tipo=''
  }

if(this.AnalisisSaldos.tipo.codigo==undefined){

this.alerta("Seleccione un tipoProveedor", "error");
this.AnalisisSaldos.tipo=''
return

}

},



cargarProveedor(){


this.$axios.get(this.$hostname+this.$hName+'/proveedores/findallbyDesc/25/0/*',{headers:this.$store.getters.GetheadersAxios})
.then(res=>( this.Rproveedor=res.data))



},


SelctCbProveedor(){
  if(this.AnalisisSaldos.proveedor==null){

    this.AnalisisSaldos.proveedor=''
  }

if(this.AnalisisSaldos.proveedor.codigo== undefined){

this.alerta("Seleccione un proveedor", "error");
this.AnalisisSaldos.proveedor=''

//qlq2

return

}

},

CbFilProveedor(e) {
     

if (e.target.value.length >= 0) {
          this.$axios
            .get(
              this.$hostname +
              this.$hName +
              "/proveedores/findallbyDesc/25/0/"+(e.target.value===""?"*":e.target.value),
              {headers:this.$store.getters.GetheadersAxios}
            )
            .then(res => (this.Rproveedor = res.data));
        }
    },


Blurfecha(){

if(this.AnalisisSaldos.fecha.toString().length==0){
  this.AnalisisSaldos.fecha=this.fechaNueva()
}

 },


    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
      }
    },




    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {}
  }
};
</script>

<style></style>
